import { render, staticRenderFns } from "./StatsProdToday.vue?vue&type=template&id=6c40370c&scoped=true&lang=html&"
import script from "./StatsProdToday.vue?vue&type=script&lang=js&"
export * from "./StatsProdToday.vue?vue&type=script&lang=js&"
import style0 from "./StatsProdToday.vue?vue&type=style&index=0&id=6c40370c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c40370c",
  null
  
)

export default component.exports